import '../assets/scss/index.scss'

import { Box, Grid, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import AllUsers from '../components/widgets/AllUsers'

const RegisterPage: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  return (
    <Box sx={{ mx: isMobile ? 2 : 5, my: 3, height: '100%', display: 'flex', justifyContent: 'center' }}>
      <Grid
        container
        spacing={{ xs: 2, sm: 2, md: 2, lg: 3 }}
      >
        <Grid item xs={12}>
          <AllUsers />
        </Grid>
      </Grid>
    </Box>
  )
}

export default RegisterPage
